import { Button } from '@/components/ui/button'
import { useQueryParams } from '@/contexts/QueryParamContext'

const CTAButton = ({
  className = '',
  text = 'START YOUR CLAIM NOW',
  link = 'https://app.claims1.co.uk/NewClaimantDetails/',
  disabled = false,
  testId = 'cta-start-claim',
}) => {
  const { appendQueryParams } = useQueryParams()

  const handleClick = () => {
    if (disabled) return
    if (navigator.webdriver) {
      const appUrl =
        'https://' +
        window.location.hostname.replace('claims1.co.uk', 'app.claims1.co.uk') +
        '/'
      window.location.href = appendQueryParams(appUrl)
      return
    }
    window.open(appendQueryParams(link), '_blank')
  }

  return (
    <Button
      onClick={handleClick}
      data-testid={testId}
      className={`h-14 bg-[#ff914d] px-6 text-xl font-black text-[oklch(0.2205_0.0376_194.77)] uppercase ${disabled ? 'cursor-default' : 'cursor-pointer'} ${className}`}
    >
      {text}
    </Button>
  )
}

export default CTAButton
